/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Email Icon component.
 */
const SystemEmailIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.66667 7.99967L10.7384 11.0745L10.7398 11.0757C11.1919 11.4072 11.4181 11.5731 11.6659 11.6371C11.8848 11.6938 12.115 11.6938 12.334 11.6371C12.5819 11.573 12.8088 11.4067 13.2617 11.0745C13.2617 11.0745 15.8734 9.0703 17.3333 7.99967M6 14.5331V9.46647C6 8.71973 6 8.34609 6.14533 8.06087C6.27315 7.80999 6.47698 7.60616 6.72787 7.47833C7.01308 7.33301 7.38673 7.33301 8.13347 7.33301H15.8668C16.6135 7.33301 16.9864 7.33301 17.2716 7.47833C17.5225 7.60616 17.727 7.80999 17.8548 8.06087C18 8.34581 18 8.719 18 9.46428V14.5354C18 15.2807 18 15.6533 17.8548 15.9383C17.727 16.1891 17.5225 16.3933 17.2716 16.5211C16.9867 16.6663 16.614 16.6663 15.8687 16.6663H8.13127C7.38599 16.6663 7.0128 16.6663 6.72787 16.5211C6.47698 16.3933 6.27315 16.1891 6.14533 15.9383C6 15.6531 6 15.2799 6 14.5331Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};

export default React.memo(SystemEmailIcon);
